import { getDetailContent } from '@utils/helpers/detailHelpers';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

import { ActionType } from '../../../../reducers/reducer';
import { useStateContext } from '../../../../reducers/state';
import CloseXButton from '../../../bits/icons/CloseXButton';
import styles from './index.module.scss';

const Details = (): JSX.Element => {
  const [active, setActive] = useState(false);
  const { state, dispatch } = useStateContext();
  const [details, setDetails] = useState(null);
  const router = useRouter();

  useEffect(() => {
    const path = router.pathname.replace('[slug]', String(router.query.slug));

    if (active) {
      document.documentElement.style.overflowY = 'hidden';

      const data = state.data.data;

      router.push(
        {
          pathname: path,
          query: { type: data?._type, id: data?._key },
        },

        undefined,
        { shallow: true }
      );
    } else {
      document.documentElement.style.overflowY = 'scroll';
      router.push(
        {
          pathname: path,
        },
        undefined,
        { scroll: false }
      );
    }

    return () => {
      document.documentElement.style.overflowY = 'scroll';
    };
  }, [active]);

  useEffect(() => {
    if (state?.data?.data) {
      const data = state?.data?.data;
      const detailsElement = getDetailContent(data);

      if (detailsElement) {
        setActive(true);
        setDetails(detailsElement);
      }
    } else {
      setActive(false);
    }
  }, [state]);

  useEffect(() => {
    const loc = String(document.location);
    const params = new URL(loc).searchParams;
    const type = params.get('type');
    const id = params.get('id');

    if (!type || !id) {
      if (active) {
        dispatch({ type: ActionType.DATA, payload: null });
      }
    }
  }, [router]);

  return (
    <div className={`${styles.root} ${active ? styles['active'] : null}`}>
      <div className={`${styles['_content-wrapper']} ${active ? styles['active'] : null}`}>
        <header className={styles['_header']}>
          <button
            className={styles['_close']}
            onClick={() => dispatch({ type: ActionType.DATA, payload: null })}>
            <CloseXButton color={'black'} onClick={() => setActive(false)} />
          </button>
        </header>
        {active && <div className={styles['_content']}>{details}</div>}
      </div>
    </div>
  );
};

export default Details;
